<template>
  <div class="col-md-6 p-3 bg-secondary">
    <div class="col-md-6 w-100">
      <div class="card card-body bg-dark text-white">
        <h5 class="card-title">{{ msg }}</h5>
        <hr>
        <p class="card-text kpi-text">{{ kpiValue(totalData, dictKey) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    msg: String,
    dictKey: String,
    totalData: Object
  },
  methods: {
    kpiValue: function (totalData, dictKey) {
      if (Object.keys(totalData).length > 0) {
        return totalData[dictKey].toLocaleString()
      } else {
        return 0
      }
    },
  }
};
</script>

<style scoped>
.kpi-text {
  font-size: 300%;
}

.card hr {
  margin-top: 0.5rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

</style>